webpackJsonp([16681832400481],{

/***/ 90:
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	exports.__esModule = true;
	exports.Featured = undefined;
	
	var _style = __webpack_require__(11);
	
	var _style2 = _interopRequireDefault(_style);
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _ImageWrap = __webpack_require__(91);
	
	var _ImageWrap2 = _interopRequireDefault(_ImageWrap);
	
	var _theme = __webpack_require__(15);
	
	var _theme2 = _interopRequireDefault(_theme);
	
	var _Container = __webpack_require__(19);
	
	var _Container2 = _interopRequireDefault(_Container);
	
	var _md = __webpack_require__(51);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var Featured = exports.Featured = function Featured(_ref) {
	    var title = _ref.title,
	        sizes = _ref.sizes;
	    return _react2.default.createElement(
	        'div',
	        {
	            className: _style2.default.dynamic([['208921455', [_theme2.default.colors.white, _theme2.default.colors.red, _theme2.default.breakpoints.md, _theme2.default.breakpoints.lg, _theme2.default.colors.grey]]]) + ' ' + 'featured'
	        },
	        _react2.default.createElement(_ImageWrap2.default, {
	            alt: title,
	            sizes: sizes,
	            style: {
	                position: "absolute",
	                left: 0,
	                top: 0,
	                width: "100%",
	                height: "100%"
	            }
	        }),
	        _react2.default.createElement(
	            'div',
	            {
	                className: _style2.default.dynamic([['208921455', [_theme2.default.colors.white, _theme2.default.colors.red, _theme2.default.breakpoints.md, _theme2.default.breakpoints.lg, _theme2.default.colors.grey]]]) + ' ' + 'content'
	            },
	            _react2.default.createElement(
	                _Container2.default,
	                null,
	                _react2.default.createElement(
	                    'h1',
	                    {
	                        className: _style2.default.dynamic([['208921455', [_theme2.default.colors.white, _theme2.default.colors.red, _theme2.default.breakpoints.md, _theme2.default.breakpoints.lg, _theme2.default.colors.grey]]])
	                    },
	                    title
	                )
	            )
	        ),
	        _react2.default.createElement(_style2.default, {
	            styleId: '208921455',
	            css: ['.featured.__jsx-style-dynamic-selector{display:block;position:relative;height:450px;line-height:1.5;margin-bottom:2em;}', '.content.__jsx-style-dynamic-selector{position:absolute;bottom:0;width:100%;z-index:2;color:' + _theme2.default.colors.white + ';background-color:' + _theme2.default.colors.red + ';}', '.content.__jsx-style-dynamic-selector h1.__jsx-style-dynamic-selector{font-size:1.5em;line-height:2em;margin-bottom:0;}', '@media(min-width:' + _theme2.default.breakpoints.md + 'px){.content.__jsx-style-dynamic-selector h1.__jsx-style-dynamic-selector{font-size:2em;}}', '@media(min-width:' + _theme2.default.breakpoints.lg + 'px){.content.__jsx-style-dynamic-selector{background-color:#eee;color:' + _theme2.default.colors.grey + ';}}'],
	            dynamic: [_theme2.default.colors.white, _theme2.default.colors.red, _theme2.default.breakpoints.md, _theme2.default.breakpoints.lg, _theme2.default.colors.grey]
	        })
	    );
	};
	
	var Hero = function Hero(props) {
	    return _react2.default.createElement(
	        'div',
	        {
	            className: _style2.default.dynamic([['3526713250', [_theme2.default.colors.red, _theme2.default.colors.white, _theme2.default.colors.white, _theme2.default.colors.red, _theme2.default.breakpoints.md, _theme2.default.breakpoints.lg, _theme2.default.breakpoints.lg]]]) + ' ' + 'hero'
	        },
	        _react2.default.createElement(_ImageWrap2.default, {
	            alt: 'Norwich Castle',
	            sizes: props.sizes,
	            style: {
	                position: "absolute",
	                left: 0,
	                top: 0,
	                width: "100%",
	                height: "100%"
	            }
	        }),
	        _react2.default.createElement(
	            'div',
	            {
	                className: _style2.default.dynamic([['3526713250', [_theme2.default.colors.red, _theme2.default.colors.white, _theme2.default.colors.white, _theme2.default.colors.red, _theme2.default.breakpoints.md, _theme2.default.breakpoints.lg, _theme2.default.breakpoints.lg]]]) + ' ' + 'content'
	            },
	            _react2.default.createElement(
	                'h2',
	                {
	                    className: _style2.default.dynamic([['3526713250', [_theme2.default.colors.red, _theme2.default.colors.white, _theme2.default.colors.white, _theme2.default.colors.red, _theme2.default.breakpoints.md, _theme2.default.breakpoints.lg, _theme2.default.breakpoints.lg]]])
	                },
	                'Castle Electrical Services Ltd'
	            ),
	            _react2.default.createElement(
	                'h1',
	                {
	                    className: _style2.default.dynamic([['3526713250', [_theme2.default.colors.red, _theme2.default.colors.white, _theme2.default.colors.white, _theme2.default.colors.red, _theme2.default.breakpoints.md, _theme2.default.breakpoints.lg, _theme2.default.breakpoints.lg]]])
	                },
	                'Norwich Electrical Contractors'
	            ),
	            _react2.default.createElement(
	                'p',
	                {
	                    className: _style2.default.dynamic([['3526713250', [_theme2.default.colors.red, _theme2.default.colors.white, _theme2.default.colors.white, _theme2.default.colors.red, _theme2.default.breakpoints.md, _theme2.default.breakpoints.lg, _theme2.default.breakpoints.lg]]])
	                },
	                'Qualified Electricians based in Eaton, Norwich. Carrying out all types of Electrical Wiring, Electrical Testing, covering Norwich, Norfolk, Suffolk and East Anglia.'
	            ),
	            _react2.default.createElement(
	                'button',
	                { onClick: props.scrollHandler, className: _style2.default.dynamic([['3526713250', [_theme2.default.colors.red, _theme2.default.colors.white, _theme2.default.colors.white, _theme2.default.colors.red, _theme2.default.breakpoints.md, _theme2.default.breakpoints.lg, _theme2.default.breakpoints.lg]]])
	                },
	                _react2.default.createElement(_md.MdArrowDropDown, null)
	            )
	        ),
	        _react2.default.createElement(_style2.default, {
	            styleId: '3526713250',
	            css: ['.hero.__jsx-style-dynamic-selector{display:block;position:relative;height:400px;line-height:1.5;}', 'button.__jsx-style-dynamic-selector{display:none;cursor:pointer;background-color:' + _theme2.default.colors.red + ';padding:0;line-height:0;outline:none;border:none;margin-top:3rem;font-size:6rem;border-radius:3rem;}', 'button.__jsx-style-dynamic-selector svg{margin:0;padding:0;line-height:0;fill:' + _theme2.default.colors.white + ';}', '.hero.__jsx-style-dynamic-selector:after{display:block;position:absolute;content:\'\';left:0;right:0;top:0;bottom:0;z-index:1;background-color:rgba(0,0,0,0.4);}', '.content.__jsx-style-dynamic-selector{position:absolute;z-index:3;min-width:250px;color:' + _theme2.default.colors.white + ';left:50%;top:50%;-webkit-transform:translate(-50%,-50%);-ms-transform:translate(-50%,-50%);transform:translate(-50%,-50%);}', '.content.__jsx-style-dynamic-selector h1.__jsx-style-dynamic-selector{text-transform:uppercase;font-size:1.5em;line-height:1;margin:0;}', '.content.__jsx-style-dynamic-selector h2.__jsx-style-dynamic-selector{font-size:1em;display:inline-block;padding:.5em .4em;border-radius:.4em;background-color:rgba(255,255,255,0.5);color:' + _theme2.default.colors.red + ';margin-bottom:1em;}', '.content.__jsx-style-dynamic-selector p.__jsx-style-dynamic-selector{font-weight:normal;margin-top:1em;font-size:14px;}', '@media(min-width:' + _theme2.default.breakpoints.md + 'px){.content.__jsx-style-dynamic-selector h1.__jsx-style-dynamic-selector{font-size:2em;}.content.__jsx-style-dynamic-selector p.__jsx-style-dynamic-selector{font-size:1em;}}', '@media(min-width:' + _theme2.default.breakpoints.lg + 'px) and ( max-height:650px){button.__jsx-style-dynamic-selector{display:none !important;}}', '@media(min-width:' + _theme2.default.breakpoints.lg + 'px){button.__jsx-style-dynamic-selector{display:block;}.hero.__jsx-style-dynamic-selector{height:100vh;}.content.__jsx-style-dynamic-selector h1.__jsx-style-dynamic-selector{font-size:3.5em;}.content.__jsx-style-dynamic-selector p.__jsx-style-dynamic-selector{font-size:1.2em;}}'],
	            dynamic: [_theme2.default.colors.red, _theme2.default.colors.white, _theme2.default.colors.white, _theme2.default.colors.red, _theme2.default.breakpoints.md, _theme2.default.breakpoints.lg, _theme2.default.breakpoints.lg]
	        })
	    );
	};
	
	exports.default = Hero;

/***/ }),

/***/ 240:
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	exports.__esModule = true;
	exports.pageQuery = undefined;
	exports.default = Template;
	
	var _style = __webpack_require__(11);
	
	var _style2 = _interopRequireDefault(_style);
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _reactHelmet = __webpack_require__(50);
	
	var _reactHelmet2 = _interopRequireDefault(_reactHelmet);
	
	var _theme = __webpack_require__(15);
	
	var _theme2 = _interopRequireDefault(_theme);
	
	var _Hero = __webpack_require__(90);
	
	var _Container = __webpack_require__(19);
	
	var _Container2 = _interopRequireDefault(_Container);
	
	var _Accreditations = __webpack_require__(37);
	
	var _Accreditations2 = _interopRequireDefault(_Accreditations);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function Template(_ref) {
		var data = _ref.data;
		var markdownRemark = data.markdownRemark;
		var frontmatter = markdownRemark.frontmatter,
		    html = markdownRemark.html,
		    excerpt = markdownRemark.excerpt;
	
	
		return _react2.default.createElement(
			'div',
			{
				className: _style2.default.dynamic([['1329046758', [_theme2.default.colors.grey, _theme2.default.colors.red, _theme2.default.breakpoints.lg]]]) + ' ' + 'service'
			},
			_react2.default.createElement(_reactHelmet2.default, {
				title: frontmatter.title + ' | Castle Electrical Services Ltd',
				meta: [{ name: 'description', content: excerpt }, { property: 'og:title', content: '' + frontmatter.title }, { property: 'og:type', content: 'article' }, { property: 'og:description', content: excerpt }, { property: 'og:url', content: ("https://johnwilson65.github.io") + '/services/' + frontmatter.navtitle }, { property: 'og:site_name', content: 'Castle Electrical Services Ltd' }, { property: 'og:image', content: ("https://johnwilson65.github.io") + '/logos/logo-1024.png' }],
				htmlAttributes: { 'lang': 'en' }
			}),
			_react2.default.createElement(_Hero.Featured, { title: frontmatter.title, sizes: frontmatter.featuredImage.childImageSharp.sizes }),
			_react2.default.createElement(_Accreditations2.default, { data: data }),
			_react2.default.createElement(
				_Container2.default,
				null,
				_react2.default.createElement('div', {
					dangerouslySetInnerHTML: { __html: html },
					className: _style2.default.dynamic([['1329046758', [_theme2.default.colors.grey, _theme2.default.colors.red, _theme2.default.breakpoints.lg]]]) + ' ' + 'service-content'
				})
			),
			_react2.default.createElement(_style2.default, {
				styleId: '1329046758',
				css: ['.service.__jsx-style-dynamic-selector{line-height:1.5;padding-bottom:2em;}', '.service.__jsx-style-dynamic-selector h1.__jsx-style-dynamic-selector,.service.__jsx-style-dynamic-selector h2.__jsx-style-dynamic-selector{color:' + _theme2.default.colors.grey + ';padding-bottom:.5rem;border-bottom:2px solid ' + _theme2.default.colors.red + ';}', '@media(min-width:' + _theme2.default.breakpoints.lg + 'px){.service.__jsx-style-dynamic-selector{padding-top:93px;}}'],
				dynamic: [_theme2.default.colors.grey, _theme2.default.colors.red, _theme2.default.breakpoints.lg]
			})
		);
	};
	
	var pageQuery = exports.pageQuery = '** extracted graphql fragment **';

/***/ })

});


// WEBPACK FOOTER //
// component---src-templates-service-template-js-76ce63ea6942211b8487.js